import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type UseDeleteGovernmentAllocationEntryProductCategoryProps = {
  governmentAllocationId: string
  onSuccess: () => void
  onError: (error: AxiosError) => void
}

export const useDeleteGovernmentAllocationEntryProductCategory = ({
  governmentAllocationId,
  onSuccess,
  onError,
}: UseDeleteGovernmentAllocationEntryProductCategoryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteGovernmentAllocationEntryProductCategory', governmentAllocationId],
    mutationFn: async (entryProductCategoryId: string) => {
      const government_allocation_entry = {
        entry_product_categories_attributes: [
          {
            id: entryProductCategoryId,
            _destroy: true,
          },
        ],
      }

      return privateAxios.put(`/billing/government_allocation_entries/${governmentAllocationId}`, {
        government_allocation_entry,
      })
    },
    onSuccess,
    onError,
  })
}
